import { apiClient } from "../config";

async function getAllPrograms(searchQuery?: string, page?: number) {
  const params = {
    searchString: searchQuery,
    page: page,
    entity: "programs",
    module: "protocol"
  };

  const res = await apiClient.get(`/admin/users/drop-down`, { params });
  return res.data;
}

export default getAllPrograms;
